import styled from 'styled-components';

import CellWrapper from './CellWrapper';
import { Monospace, Normal } from '../Table/Table.styled';

export const RowHeaderWrapper = styled(CellWrapper)`
  text-align: left;
  justify-content: space-between;
  padding-left: 5px;
  gap: 5px;
`;

interface RowHeaderCellProps {
  value: string;
  children?: React.ReactNode;
}

export default function RowHeaderCell({ value, children }: RowHeaderCellProps) {
  // Function to format the value string by wrapping text in parentheses with <small> tags
  const formatValue = (text: string) => {
    const regex = /(\([^)]+\))/g;

    // Split the string by matched parentheses patterns
    const parts = text.split(regex);

    return parts.map((part, index) => {
      // Check if this part is a parenthetical expression
      if (part.match(regex)) {
        // Return the parenthetical content wrapped in <small> tag
        return <Normal key={index}>{part}</Normal>;
      }
      // Return regular text as is
      return part;
    });
  };

  return (
    <RowHeaderWrapper>
      <Monospace>{formatValue(value)}</Monospace>
      {children}
    </RowHeaderWrapper>
  );
}
